import { useEffect, useRef } from 'react';
import { useLocation, withRouter } from 'react-router-dom';

const ScrollToTop = (props) => {
  const location = useLocation();
  const isFirstRender = useRef(true);
  const hasRestoredScroll = useRef(false);

  // Restore scroll position on initial load (runs once)
  useEffect(() => {
    if (isFirstRender.current) {
      const savedScroll = sessionStorage.getItem(`scroll-${location.pathname}`);
      if (savedScroll) {
        hasRestoredScroll.current = true;
        // Longer delay to ensure content is rendered
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScroll, 10));
          // Allow saving again after restore is complete
          setTimeout(() => { hasRestoredScroll.current = false; }, 100);
        }, 100);
      }
      isFirstRender.current = false;
    }
  }, []);

  // Save scroll position on scroll (but not during restore)
  useEffect(() => {
    const handleScroll = () => {
      if (!hasRestoredScroll.current) {
        sessionStorage.setItem(`scroll-${location.pathname}`, window.scrollY.toString());
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Scroll to top when navigating within app (not on first render)
  useEffect(() => {
    if (!isFirstRender.current) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return props.children;
}

export default withRouter(ScrollToTop);
